import { createVictorConsoleApi } from "@victor/api-client/console";

/**
 * Lecture du token d'accès courant via window var (posée par AuthContext).
 * On évite localStorage pour le token (XSS) · il reste en mémoire.
 */
function getAuthToken(): string | null {
  return window.__victorAdminToken ?? null;
}

declare global {
  interface Window {
    __victorAdminToken?: string | null;
  }
}

export const api = createVictorConsoleApi({
  baseUrl:
    (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "",
  getAuthToken,
});

export function setAccessToken(token: string | null): void {
  window.__victorAdminToken = token;
}
